module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "nextpara"
  }), _vm._v(" "), _c('p', {
    staticClass: "Book_Title_Book_NOTHING-S"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nothing’s")])]), _vm._v(" "), _c('p', {
    staticClass: "Book_Title_Book_Wrong ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "Book_Title_Book_Sub-title"
  }, [_vm._v("A man’s guide to managin"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("g emotions")])]), _vm._v(" "), _c('p', {
    staticClass: "Book_Title_Book_Author"
  }), _vm._v(" "), _c('p', {
    staticClass: "Book_Title_Book_Author"
  }, [_vm._v("DA"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("VID KUNDTZ")])]), _vm._v(" "), _c('p', {
    staticClass: "Book_Title_Conari-_logo"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cplogo_titlepage.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Book_Title_Coral-Gables _idGenParaOverride-1"
  }, [_vm._v("Coral "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Gables, FL")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77159f44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NothingsWrong-1.vue
// module id = 63
// module chunks = 0